import $ from 'jquery';
import { getUser } from '~src/user';

export const onLinkServizio = async (event) => {
  event.preventDefault();
  event.stopPropagation();

  const { user } = await getUser();
  const { plan } = user.org_pointer;

  if (plan && plan.toLowerCase().includes('giotto')) {
    // Non-Eterno
    const eternoVideoUrl = 'https://www.youtube.com/embed/yKxWm9DrE_A';
    $('#tryEternoVideo').attr(
      'src',
      eternoVideoUrl + '?autoplay=0&amp;modestbranding=1&amp;showinfo=0'
    );
    $('#tryEternoVideo').data('src');
    $('#modalTryEterno').modal('show');
  } else {
    window.open(event.currentTarget.href, '_blank');
  }
};
